var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { media } from '@gympass/yoga-helpers';
var desktop = media.lg(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var grid = _ref.theme.yoga.components.grid;
  return "\n    grid-column-gap: " + grid.gutter.desktop + "px;\n  ";
});
var mobile = media.xxs(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var grid = _ref2.theme.yoga.components.grid;
  return "\n    grid-column-gap: " + grid.gutter.mobile + "px;\n  ";
});
var Row = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: grid;\n  box-sizing: border-box;\n\n  grid-template-columns: repeat(12, 1fr);\n\n  ", "\n  ", "\n"])), mobile, desktop);
export default Row;